import React from "react";
import { ExternalLink, MapPin } from "lucide-react";
import { formatPrice } from "@/lib/api";

export default function AcquisitionResults({ results, searching }) {
    if (searching) return <div data-testid="acq-results-loading" className="rounded-lg bg-white p-8 text-center text-sm text-slate-500 shadow-[6px_6px_16px_#cad5e2,-6px_-6px_16px_#ffffff]">Ricerca sui portali in corso…</div>;
    if (!results) return <div data-testid="acq-results-idle" className="rounded-lg border border-dashed border-blue-200 bg-white/60 p-8 text-center text-sm text-slate-500">Disegna l’area, imposta i filtri e avvia la ricerca.</div>;
    const items = results.items || [];
    return (
        <section data-testid="acq-results" className="mt-6">
            <div className="flex items-center justify-between gap-3 flex-wrap mb-4">
                <div><span data-testid="acq-results-count" className="text-sm font-semibold text-slate-900">{items.length} immobili trovati</span><span className="text-xs text-slate-500 ml-2">· {results.new_count} nuovi</span></div>
                <span className="text-xs text-slate-400">provider: {results.provider}</span>
            </div>
            {items.length === 0 ? (
                <div data-testid="acq-results-empty" className="rounded-lg bg-white p-8 text-center text-sm text-slate-500 shadow-[6px_6px_16px_#cad5e2,-6px_-6px_16px_#ffffff]">Nessun risultato con questi filtri. Prova ad ampliare prezzo o tipologia.</div>
            ) : (
                <div className="grid grid-cols-1 2xl:grid-cols-2 gap-3">
                    {items.map((item) => (
                        <a key={item.id} href={item.url} target="_blank" rel="noopener noreferrer" data-testid={`acq-result-${item.id}`} className="min-w-0 rounded-lg bg-white border border-white p-4 shadow-[5px_5px_14px_#cad5e2,-5px_-5px_14px_#ffffff] hover:border-blue-300 transition-colors">
                            <div className="flex items-start justify-between gap-3">
                                <div className="min-w-0">
                                    <div className="flex items-center gap-2 text-[10px] uppercase text-blue-700 mb-2"><MapPin size={11} /> {item.source}</div>
                                    <h3 className="font-serif text-base text-slate-900 leading-snug line-clamp-2">{item.title}</h3>
                                </div>
                                <ExternalLink size={14} className="text-blue-500 shrink-0" />
                            </div>
                            <div className="flex items-center gap-3 mt-3 text-xs text-slate-600">
                                {item.price && <span className="font-semibold text-blue-700">{formatPrice(item.price)}</span>}
                                {item.sqm && <span>{item.sqm} mq</span>}
                                {item.private_score >= 70 && <span className="ml-auto text-emerald-700">Privato {item.private_score}%</span>}
                            </div>
                        </a>
                    ))}
                </div>
            )}
        </section>
    );
}